import React, { useContext, useEffect, useRef, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import ContentHeader from '../../../Layout/ContentHeader'
import LayoutTable from '../../../Global/LayoutTable'
import {
  EXPORT_TO_CSV_PREVIEW_WATER_TRUCK_REQUEST_CONCILIATION,
  EXPORT_TO_CSV_WATER_TRUCK_REQUEST_CONCILIATION,
  GET_ALL_WATER_TRUCK_REQUEST_CONCILIATIONS,
} from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequestConciliations'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import ModalContent from '../../../Global/ModalContent'
import CreateConciliationModal from './CreateConciliationModal'
import { GET_WATER_TRUCKS_IDS_AVAILABLE_CONCILIATION } from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'
import moment from 'moment'
import { GET_ALL_PROVIDERS } from '../../../../graphql/Catalog/Providers/providers'
import { CSVLink } from 'react-csv'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { currencyFormatToAny } from '../../../Helpers/FormatNumber'
import { AuthContext } from '../../../../Auth/AuthContext'
import { useLocation } from 'react-router'
import Select from 'react-select'
import { objNameRoles } from '../../../../const/constRoles'

const Conciliation = () => {
  const MySwal = withReactContent(Swal)
  const { showLoading, hideLoading } = useLoading()
  const { user } = useContext(AuthContext)
  const location = useLocation()

  const columnDateType = [
    {
      value: 'date_conciliation_start',
      label: 'Fecha de inicio',
    },
    {
      value: 'date_conciliation_end',
      label: 'Fecha de fin',
    },
  ]

  //------- REFS:
  const refModalStatus = useRef(null)
  const selectRef = useRef(null)

  //------- STATES:
  const [showCreateButton, setShowCreateButton] = useState(false)
  const [isProvider, setIsProvider] = useState(false)
  const [dataToExport, setDataToExport] = useState([])
  const [nameFileToExport, setNameFileToExport] = useState(null)
  const [pipesGestor, setPipesGestor] = useState(false)
  const [options, setOptions] = useState({
    providers: [],
  })
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    filters: {
      dateFrom: null,
      dateTo: null,
      columnDate: 'date_conciliation_start',
      provider_id: null,
    },
  })

  const [dataToTable, setDataToTable] = useState({
    data: [],
    total: 0,
  })

  const [modal, setModal] = useState({
    modalId: false,
    size: 'extra',
    title: '',
    content: null,
  })

  const [filterChoosen, setFilterChoosen] = useState([])

  //------- QUERIES:
  const { loading, error, data, refetch } = useQuery(
    GET_ALL_WATER_TRUCK_REQUEST_CONCILIATIONS,
    {
      variables: {
        searchQuery: pagePagination.searchQuery,
        limit: pagePagination.limit,
        offset: pagePagination.offset,
        filters: pagePagination.filters,
      },
      fetchPolicy: 'no-cache',
    }
  )

  const {
    loading: loadingProvider,
    error: errorProvider,
    data: dataProvider,
  } = useQuery(GET_ALL_PROVIDERS, {
    variables: {},
    fetchPolicy: 'no-cache',
    skip: isProvider,
  })

  const [GetWaterTrucksIds] = useMutation(
    GET_WATER_TRUCKS_IDS_AVAILABLE_CONCILIATION
  )

  const [ExportCSVConciliation] = useMutation(
    EXPORT_TO_CSV_WATER_TRUCK_REQUEST_CONCILIATION
  )

  const [ExportPreviewConciliation] = useMutation(
    EXPORT_TO_CSV_PREVIEW_WATER_TRUCK_REQUEST_CONCILIATION
  )

  //------- VALIDATE IF USER IS PIPES MANAGER:
  useEffect(() => {
    if (!user) return
    if (user.role === objNameRoles.gestor_pipas) {
      setPipesGestor(true)
    }
  }, [user])

  //------- EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error) return toastSweetAlert({ type: 'error', text: error.message })

      let list = []
      data?.getAllWaterTruckRequestConciliations?.rows.map((item) => {
        return list.push({
          id: item.id,
          'Fecha de conciliación': `${
            item.date_conciliation_start === item.date_conciliation_end
              ? `${moment(item.date_conciliation_start).format('DD/MM/YYYY')}`
              : `${moment(item.date_conciliation_start).format(
                  'DD/MM/YYYY'
                )} - ${moment(item.date_conciliation_end).format('DD/MM/YYYY')}`
          }`, //Before: dddd D [de] MMMM [de] YYYY
          Solicitudes: item.totalRequests,
          'm3 surtidos': item.total_m3,
          'Descargas de cisterna': item.total_discharge_into_cisterns,
          'Descargas casa': item.total_discharge_into_homes,
          // Acciones: (
          //   <div className="d-flex justify-content-around">
          //     <Link
          //       className="btn btn-migrates btn-sm"
          //       to={`conciliation/details/${item.id}/show`}
          //     >
          //       Detalle
          //     </Link>
          //     <a className="btn btn-migrates btn-sm">Detalle</a>
          //     <a className="btn btn-migrates btn-sm" href="">
          //       Generar PDF
          //     </a>
          //   </div>
          // ),
        })
      })

      setDataToTable({
        data: list,
        total: data.getAllWaterTruckRequestConciliations.count,
      })
      setIsProvider(data.getAllWaterTruckRequestConciliations.flags.isProvider)
    }
  }, [data, loading, error])

  useEffect(() => {
    const permissions = user?.userPermissions
    const createPermission = permissions.find(
      (item) => item?.module_info?.relative_link === location.pathname
    )
    setShowCreateButton(createPermission?.access_retrieve)
  }, [location.pathname, user])

  useEffect(() => {
    try {
      if (isProvider) return
      if (loadingProvider) return
      if (errorProvider) throw new Error(errorProvider.message)

      const providers = dataProvider.getAllProviders.rows.map((item) => {
        return {
          label: `${item.card_name} - ${item.rfc}`,
          value: item.id,
        }
      })

      setOptions({
        providers: providers,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingProvider, errorProvider, dataProvider])

  //------- Functions:
  const handleDateConciliation = async () => {
    MySwal.fire({
      title: 'Fechas de conciliación',
      text: 'Por favor, ingrese las fechas de conciliación',
      html: (
        <div
          className="message-container d-flex mt-3 mb-3"
          style={{ justifyContent: 'space-around' }}
        >
          <div className="input-container text-left" style={{ width: '40%' }}>
            <label htmlFor="date_conciliation_start">Fecha de inicio</label>
            <input
              className="input-field form-control"
              type="date"
              id="date_conciliation_start"
            />
          </div>
          <div className="input-container text-left" style={{ width: '40%' }}>
            <label htmlFor="date_conciliation_end">Fecha de fin</label>
            <input
              className="input-field form-control"
              type="date"
              id="date_conciliation_end"
            />
          </div>
        </div>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates dd',
        denyButton:
          'btn btn-migrates-white export-reports-buttons-right',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const date_conciliation_start = document.getElementById(
          'date_conciliation_start'
        ).value
        const date_conciliation_end = document.getElementById(
          'date_conciliation_end'
        ).value

        if (!date_conciliation_start || !date_conciliation_end) {
          return toastSweetAlert({
            mode: 'error',
            message: 'Por favor, ingrese las fechas de conciliación',
          })
        }

        if (
          new Date(date_conciliation_start) > new Date(date_conciliation_end)
        ) {
          return toastSweetAlert({
            mode: 'error',
            message:
              'La fecha de inicio no puede ser mayor que la fecha de fin',
          })
        }
        // Continue with the logic after validation
        const conciliationsIds = await GetWaterTrucksIds({
          variables: {
            dateFrom: date_conciliation_start,
            dateTo: date_conciliation_end,
          },
        })
        if (
          conciliationsIds?.data?.getWaterTrucksIdsAvailableConciliation
            .length === 0
        )
          return toastSweetAlert({
            mode: 'error',
            message: 'No hay datos para conciliar en las fechas seleccionadas',
          })

        let title = ''
        if (date_conciliation_start === date_conciliation_end) {
          title = `Solicitudes completadas del ${moment(
            date_conciliation_start
          ).format('dddd D [de] MMMM [de] YYYY')}`
        } else {
          title = `Solicitudes completadas del ${moment(
            date_conciliation_start
          ).format('dddd D [de] MMMM [de] YYYY')} al ${moment(
            date_conciliation_end
          ).format('dddd D [de] MMMM [de] YYYY')}`
        }

        setModal({
          id: 1,
          modalId: `modal${1}`,
          size: 'extra',
          title,
          content: (
            <CreateConciliationModal
              date_conciliation_start={date_conciliation_start}
              date_conciliation_end={date_conciliation_end}
              conciliationsIds={
                conciliationsIds.data.getWaterTrucksIdsAvailableConciliation
              }
              refModal={refModalStatus}
              refetch={refetch}
            />
          ),
        })
        refModalStatus.current.click()
      }
    })
  }

  const handlePreviewConciliation = async () => {
    MySwal.fire({
      title: 'Datos para simulación de conciliación',
      html: (
        <div className="message-container d-flex flex-column gap-3">
          <div className="d-flex justify-content-around gap-3">
            <div className="input-container">
              <label htmlFor="date_conciliation_start">Fecha de inicio</label>
              <input
                className="input-field form-control"
                type="date"
                id="date_conciliation_start"
              />
            </div>
            <div className="input-container">
              <label htmlFor="date_conciliation_end">Fecha de fin</label>
              <input
                className="input-field form-control"
                type="date"
                id="date_conciliation_end"
              />
            </div>
          </div>
          <div className="input-container">
            <Select
              ref={selectRef}
              inputId="providers"
              options={options.providers}
              // isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              placeholder="Seleccione un proveedor"
            />
          </div>
        </div>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
      preConfirm: () => {
        const date_conciliation_start = document.getElementById(
          'date_conciliation_start'
        )?.value
        const date_conciliation_end = document.getElementById(
          'date_conciliation_end'
        )?.value
        const selectedOption = selectRef.current?.getValue?.()[0]

        if (
          !date_conciliation_start ||
          !date_conciliation_end ||
          !selectedOption
        ) {
          MySwal.showValidationMessage(
            'Por favor, complete todos los campos requeridos'
          )
          return false
        }

        if (
          new Date(date_conciliation_start) > new Date(date_conciliation_end)
        ) {
          MySwal.showValidationMessage(
            'La fecha de inicio no puede ser mayor que la fecha de fin'
          )
          return false
        }

        return {
          date_conciliation_start,
          date_conciliation_end,
          provider: selectedOption.value,
        }
      },
    })
      .then((result) => {
        if (result.isConfirmed && result.value) {
          const { date_conciliation_start, date_conciliation_end, provider } =
            result.value

          handleQueryPreviewConciliation(
            date_conciliation_start,
            date_conciliation_end,
            provider
          )
        }
      })
      .catch((error) => {})
  }

  const handleCloseModal = () => {
    setModal({
      title: '',
      content: null,
      modalId: null,
      size: 'extra',
    })
  }

  const formatDate = (date) => {
    // ;`'${moment(request.createdAt).format('DD/MM/YYYY h:mm:ss A')}`
    // ;`=""${item.codigo_producto}""`
    // return `=""${moment(date).format('DD/MM/YYYY h:mm:ss A')}""`
    // return `'${moment(date).format('DD/MM/YYYY h:mm:ss A').replace("'", '')}'`
    return moment(date).format('DD/MM/YYYY HH:mm:ss')
  }

  const handleGenerateCSV = async (id) => {
    showLoading()
    try {
      const { data: dataExport } = await ExportCSVConciliation({
        variables: {
          id,
        },
        fetchPolicy: 'no-cache',
      })

      if (!dataExport.ExportToCsvWaterTruckRequestConciliationById)
        throw new Error('Error al exportar el archivo')

      exportCSV(
        dataExport.ExportToCsvWaterTruckRequestConciliationById
          .WaterTruckRequestConciliationToWaterRequest,
        dataExport.ExportToCsvWaterTruckRequestConciliationById
          .date_conciliation_start,
        dataExport.ExportToCsvWaterTruckRequestConciliationById
          .date_conciliation_end,
        false
      )
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleQueryPreviewConciliation = async (
    date_conciliation_start,
    date_conciliation_end,
    provider
  ) => {
    showLoading()
    try {
      const { data: dataExport } = await ExportPreviewConciliation({
        variables: {
          dateConciliationStart: date_conciliation_start,
          dateConciliationEnd: date_conciliation_end,
          providerId: provider,
        },
        fetchPolicy: 'no-cache',
      })

      if (!dataExport) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Error al exportar el archivo',
        })
      }

      if (!dataExport.ExportToCsvPreviewWaterTruckRequestConciliation) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Error al exportar el archivo',
        })
      }

      exportCSV(
        dataExport.ExportToCsvPreviewWaterTruckRequestConciliation,
        date_conciliation_start,
        date_conciliation_end,
        true
      )
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const exportCSV = async (dataExport, dateStart, dateEnd, preview) => {
    try {
      if (!dataExport) {
        throw new Error('Error al exportar el archivo')
      }

      if (dataExport.length === 0) {
        throw new Error('No hay datos para exportar')
      }

      let infoExport = []
      let totalHouse = 0
      let totalCistern = 0
      let trucksCapacity = []

      let infoCSV = dataExport
      infoCSV = infoCSV.sort((a, b) => {
        return (
          a.RoutesOfWaterTruckRequest.truck_id -
          b.RoutesOfWaterTruckRequest.truck_id
        )
      })

      infoCSV = infoCSV.sort((a, b) => {
        return (
          a.RoutesOfWaterTruckRequest.RouteToTrucks.capacity -
          b.RoutesOfWaterTruckRequest.RouteToTrucks.capacity
        )
      })

      infoCSV.map((request) => {
        // let extemporaneousRequest = false
        const route = request.RoutesOfWaterTruckRequest
        const trucks = route.RouteToTrucks
        const addressRequest = request.AddressOfWaterTruckRequest
        const colonyRequest = request.ColonyOfWaterTruckRequest
        const status = request.StatusOfWaterTruckRequest.name
        const routePoint = request.RoutesPointsOfWaterTruckRequest
        const provider = request.ProviderOfWaterTruckRequest
        const loadedAt = Number(routePoint.loaded_at)
        const deliveredAt = Number(routePoint.delivered_at)
        const userTruck = request.RoutesOfWaterTruckRequest.RouteToUser || null
        const operator = userTruck
          ? `${userTruck?.name} ${userTruck?.first_name || ''} ${
              userTruck?.last_name || ''
            }`
          : 'N/A'
        // const extemporaneous = request.TimelineOneWaterTruckRequest

        // if (request.is_extemporaneous) {
        //   console.log('Extemporaneous request:', request.folio)
        // }

        // if (!trucksCapacity.includes(trucks.capacity))
        //   trucksCapacity.push(trucks.capacity)
        infoExport.push({
          Nº: infoExport.length + 1,
          'ID Reporte': request.folio.toUpperCase(),
          'Estado Actual': status,
          Proveedor: provider.card_name,
          Capacidad: currencyFormatToAny({
            value: trucks.capacity * 1000,
          }),
          Placa: trucks.plate_number.toUpperCase(),
          Operador: operator,
          'Fecha de solicitud': String(formatDate(request.createdAt)),
          'Fecha de asignación': String(formatDate(routePoint.createdAt)),
          'Fecha de carga': String(formatDate(loadedAt)),
          'Fecha de descarga': String(formatDate(deliveredAt)),
          'Reporte Extemporáneo': request.is_extemporaneous ? 'Si' : 'No',
          'Tipo de servicio': request.type_delivery.toUpperCase(),
          'Lugar de descarga': colonyRequest?.name
            ? colonyRequest?.name.toUpperCase()
            : addressRequest?.city
            ? addressRequest.city.toUpperCase()
            : 'N/A',
          Comentarios: request.comments || 'N/A',
          Prioridad: request.priority || 'N/A',
        })
      })

      setDataToExport(infoExport)
      setNameFileToExport(
        `${preview ? 'Simulación_de_' : ''}Conciliación_${moment(
          dateStart
        ).format('LLLL')}_al_${moment(dateEnd).format('LLLL')}.csv`
      )

      setTimeout(() => {
        document.getElementById('export-conciliation').click()
      }, 400)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleFilterChange = (e, key) => {
    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [key]: e ? e.value : null,
      },
    }))
  }

  return (
    <>
      <ContentHeader
        breadcrumb=""
        title="Conciliación"
        windowTitle="Conciliación"
        addNewButton={showCreateButton}
        addNewButtonNoPermission={showCreateButton}
        addNewButtonOnClick={
          pipesGestor ? handlePreviewConciliation : handleDateConciliation
        }
        addNewButtonText={
          pipesGestor ? 'Simulación de conciliación' : 'Crear conciliación'
        }
      />
      <LayoutTable
        data={dataToTable.data}
        title="Lista de conciliaciones"
        requery={GET_ALL_WATER_TRUCK_REQUEST_CONCILIATIONS}
        totalCount={dataToTable.total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        // showAddNewButton={showCreateButton}
        // handleAddNewButton={
        //   pipesGestor ? handlePreviewConciliation : handleDateConciliation
        // }
        // handleAddNewButtonTxt={
        //   pipesGestor ? 'Simulación de conciliación' : 'Crear conciliación'
        // }
        hideId
        // hideFilterBar
        hideAddNew
        // hideActions
        hideBtnDelete
        hideBtnEdit
        hideExport
        exportImportButton={false}
        handleButtonSecondTitle="Exportar CSV"
        handleButtonSecond={handleGenerateCSV}
        cols_search="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
        cols_search_div="col-12"
        cols_filters="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3"
        cols_filters_div="col-12"
        isFilterRangeShow
        filterRangeProps={{
          from: {
            // value: pagePagination.filters.dateFrom,
            // label: 'Fecha inicio',
          },
          to: {
            // value: pagePagination.filters.dateTo,
            // label: 'Fecha fin',
          },
          changeFilterDateRange: (e, label) => {
            const value = e.target.value
            if (label === 'from')
              return handleFilterChange({ value: value }, 'dateFrom')
            if (label === 'to')
              return handleFilterChange({ value: value }, 'dateTo')
          },
        }}
        filterThird
        filterOnChangeThird={(e) => {
          const value = e.target.value
          handleFilterChange({ value }, 'columnDate')
        }}
        filterOptionsThird={columnDateType.map((item) => (
          <option value={item.value} key={item.value}>
            {item.label}
          </option>
        ))}
        defaultValueSelectThird={'date_conciliation_start'}
        filterChoosen={[
          {
            condition: isProvider,
            id: 'provider',
            name: 'Proveedor',
            placeholder: 'Proveedor',
            options: options.providers,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'provider_id'),
            noOptionsMessage: () => 'No hay proveedores',
            classNameFull:
              'col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pl-0 pr-2',
          },
        ]}
      />

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModalStatus}
      />
      <ModalContent
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={handleCloseModal}
        content={modal.content}
      />

      <CSVLink
        id="export-conciliation"
        data={dataToExport}
        filename={nameFileToExport}
        className="d-none"
      ></CSVLink>
    </>
  )
}

export default Conciliation
